import DSBox from "views/system-design/DSBox";
import DSChip from "views/system-design/DSChip";
import { SHOPIFY_PAGES, SHOPIFY_PAGE_COLORS } from "../../types";

interface ShopifyPageChipsProps {
  selectedPage: string;
  onPageChange: (page: string) => void;
}

export default function ShopifyPageChips({
  selectedPage,
  onPageChange,
}: ShopifyPageChipsProps) {
  const hasCustomPage = !!selectedPage && !SHOPIFY_PAGES.includes(selectedPage);

  return (
    <DSBox
      role="group"
      aria-label="Shopify page selection"
      sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
    >
      {hasCustomPage && (
        <DSChip
          label={selectedPage}
          size="small"
          variant="filled"
          onClick={() => onPageChange("")}
          sx={{
            cursor: "pointer",
            bgcolor: "grey.500",
            color: "common.white",
            fontWeight: 600,
          }}
        />
      )}
      {SHOPIFY_PAGES.map((page) => {
        const isSelected = selectedPage === page;
        return (
          <DSChip
            key={page}
            label={page}
            size="small"
            variant={isSelected ? "filled" : "outlined"}
            onClick={() => onPageChange(isSelected ? "" : page)}
            sx={{
              cursor: "pointer",
              ...(isSelected && {
                bgcolor: SHOPIFY_PAGE_COLORS[page] ?? "grey.500",
                color: "common.white",
                fontWeight: 600,
              }),
            }}
          />
        );
      })}
    </DSBox>
  );
}
